'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var debug = function debug(msg) {
  if ((typeof process === 'undefined' ? 'undefined' : _typeof(process)) === 'object') {
    if (process.env.TEX_DEBUG) {
      console.log(msg);
    }
  }
};

exports.default = {
  debug: debug
};


// WEBPACK FOOTER //
// ./~/algebra-latex/lib/logger.js